module.exports = __webpack_public_path__ + "ug.e80e0413.svg";